export const enLang = {
  common: {
    lauching: 'Launching',
    showMore: 'Show more',
    share: 'Share',
  },
  bio: {
    expand: 'See more',
  },
  timer: {
    days: 'Days',
    hours: 'Hours',
    min: 'Minutes',
    sec: 'Seconds',
  },
  form: {
    email: 'Email',
    name: 'Name',
    phone: 'Phone',
    comment: 'Comment (optional)',
    address: 'Address',
    insta: 'Instagram account',
    submitEmail: 'We sent information to your email',
    total: 'Total',
    firstName: 'First Name',
    lastName: 'Last Name',
    enterName: 'First and Last Name',
    enterEmail: 'Email',
    enterAddress: 'Address',
    enterComment: 'Wripe Comment (optional)',
    thankYou: 'Thank you!',
    error: 'Something went wrong',
    successEmail: 'Your email has been successfully submitted',
    successPhone: 'Your phone has been successfully submitted',
  },
  basket: {
    addItem: 'Add to cart',
    itemAdded: 'Added to the cart',
    orderNow: 'Order Now',
    goToCart: 'Go to the cart',
    continue: 'Continue shopping',
    shoppingCart: 'Shopping cart',
    submitOrder: 'Submit order',
    cancel: 'Cancel',
    items: 'Items',
    total: 'Total',
    shipping: 'Shipping',
    shippingName: 'Enter First and Last Name',
    shippingEmail: 'Enter Email',
    shippingAddress: 'Enter Address',
    shippingComment: 'Enter Comment (optional)',
    paymentMethod: 'Payment Method',
    stripe: 'Pay with Stripe',
    wayforpay: 'Debit or Credit Card',
    cash: 'Cash',
    buttonProcessOrder: 'Process your order',
    titleEmpty: 'Your Cart is Empty',
    subtitleEmpty: "Looks like you haven't added anything to your cart yet",
    bthShopNow: 'Shop Now',
    successOrder: 'Your order was successfully submitted!',
    errorOrder: 'Your order was not submitted',
    bthHome: 'Go to Home',
    quantity: 'Qty',
  },
  contacts: {
    ask: 'Ask in',
    orderWhatsApp: 'Order on WhatsApp',
  },
  donation: {
    textBuy: 'Buy',
    fieldComment: 'Say something nice...(optional)',
    buttonSupport: 'Support',
  },
  category: {
    all: 'All',
    noItems: 'No items',
  },
  link: {
    visitLink: 'Visit Link',
  },
  error: {
    correctEmail: 'Enter correct email',
    emptyField: 'field cannot be empty',
  },
  sort: {
    title: 'Sort',
    search: 'Search',
    default: 'Default sorting',
    dateNew: 'Date: Newest to Oldest',
    dateOld: 'Date: Oldest to Newest',
    priceLow: 'Price: Low to High',
    priceHigh: 'Price: High to Low',
    nameA: 'Name: A to Z',
    nameZ: 'Name: Z to A',
  },
  shop: {
    notify: 'Notify me',
    itemsLeft: 'items left',
    notAvailable: 'Not available',
    available: 'Available',
    similar: 'You may also like',
    similarEmpty: 'Similar products not found',
  },
};

export const uaLang = {
  common: {
    lauching: 'Завантаження',
    showMore: 'Показати більше',
    share: 'Поділітися',
  },
  bio: {
    expand: 'Дивитися більше',
  },
  timer: {
    days: 'Днів',
    hours: 'Годин',
    min: 'Хвилин',
    sec: 'Секунд',
  },
  form: {
    email: 'Email',
    name: "Ім'я",
    phone: 'Телефон',
    comment: "Коментар (необов'язково)",
    address: 'Адреса',
    insta: 'Інстаграм акаунт',
    submitEmail: 'Ми надіслали інформацію на вашу почту',
    total: 'Всього',
    firstName: "Ім'я",
    lastName: 'Фамілія',
    enterName: "Введіть ім'я та прізвище",
    enterEmail: 'Введіть email',
    enterAddress: 'Введіть адресу',
    enterComment: "Напишіть коментар (необов'язково)",
    thankYou: 'Спасибі!',
    error: 'Щось пішло не так 😥',
    successEmail: 'Вашу пошту успішно надіслано',
    successPhone: 'Ваш телефон успішно надіслано',
  },
  basket: {
    addItem: 'Додати в кошик',
    itemAdded: 'Товар доданий до кошика',
    orderNow: 'Замовити',
    goToCart: 'Перейти до кошика',
    continue: 'продовжити покупки',
    shoppingCart: 'Кошик',
    submitOrder: 'Підтвердити заказ',
    cancel: 'Скасувати',
    items: 'Товари',
    total: 'Всього',
    shipping: 'Доставка',
    shippingName: 'Введіть ПІБ',
    shippingEmail: 'Введіть email',
    shippingAddress: 'Введіть адресу',
    shippingComment: "Напишіть коментар (необов'язково)",
    paymentMethod: 'Оплата',
    stripe: 'Сплатити з Stripe',
    wayforpay: 'Сплатити карткою',
    cash: 'Готівка',
    buttonProcessOrder: 'Підтвердити замовлення',
    titleEmpty: 'Ваш кошик порожній',
    subtitleEmpty: 'Ви ще нічого не додали до кошика',
    bthShopNow: 'Перейти до магазину',
    successOrder: 'Ваше замовлення успішно оформлено!',
    errorOrder: 'Ваше замовлення не оформлене',
    bthHome: 'Перейти на Головну',
    quantity: 'К-сть',
  },
  contacts: {
    ask: 'Запитати у',
    orderWhatsApp: 'Замовити у WhatsApp',
  },
  donation: {
    textBuy: 'Купити',
    fieldComment: "Напишіть щось приємне...(необов'язково)",
    buttonSupport: 'Відправити',
  },
  category: {
    all: 'Всі',
    noItems: 'Немає товарів',
  },
  link: {
    visitLink: 'Відкрити посилання',
  },
  error: {
    correctEmail: 'Введіть правильний email',
    emptyField: 'Поле не може бути порожнім',
  },
  sort: {
    title: 'Сортування',
    search: 'Пошук',
    default: 'Сортування за замовчуванням',
    dateNew: 'Дата: від новішої до найстарішої',
    dateOld: 'Дата: від найдавніших до найновіших',
    priceLow: 'Ціна: від низької до високої',
    priceHigh: 'Ціна: від високої до низької',
    nameA: 'Назва: від А до Я',
    nameZ: 'Назва: від Я до А',
  },
  shop: {
    notify: 'Залишити заявку',
    itemsLeft: 'залишилось',
    notAvailable: 'Немає в наявності',
    available: 'Є у наявності',
    similar: 'Також рекомендуємо',
    similarEmpty: 'Немає схожих товарів',
  },
};

export const esLang = {
  common: {
    lauching: 'Lanzamiento',
    showMore: 'Mostrar más',
    share: 'Cuota',
  },
  bio: {
    expand: 'Ver más',
  },
  timer: {
    days: 'Dias',
    hours: 'Horas',
    min: 'Minutos',
    sec: 'Segundos',
  },
  form: {
    email: 'Correo electrónico',
    name: 'Nombre',
    phone: 'Teléfono',
    comment: 'Comentario (opcional)',
    address: 'Dirección',
    insta: 'Cuenta de Instagram',
    submitEmail: 'Enviamos información a su correo electrónico',
    total: 'Total',
    firstName: 'Nombre de pila',
    lastName: 'Apellido',
    enterName: 'Ingrese nombre y apellido',
    enterEmail: 'Ingrese correo electrónico',
    enterAddress: 'Dirección',
    enterComment: 'Сomentario (opcional)',
    thankYou: 'Gracias!',
    error: 'Algo salió mal',
    successEmail: 'Su correo electrónico ha sido enviado con éxito',
    successPhone: 'Su teléfono ha sido enviado con éxito',
  },
  basket: {
    addItem: 'Añadir a la cesta',
    itemAdded: 'Artículo añadido a tu carrito',
    orderNow: 'Ordenar ahora',
    goToCart: 'Ir al carrito',
    continue: 'Seguir comprando',
    shoppingCart: 'Carro de la compra',
    submitOrder: 'Orden de envio',
    cancel: 'Cancelar',
    items: 'Productos',
    total: 'Total',
    shipping: 'Entrega',
    shippingName: 'Ingrese nombre y apellido',
    shippingEmail: 'Ingrese correo electrónico',
    shippingAddress: 'Ingresa la direccion',
    shippingComment: 'Introducir comentario (opcional)',
    paymentMethod: 'Método de pago',
    stripe: 'Pagar con Stripe',
    wayforpay: 'Tarjeta de débito o crédito',
    cash: 'Dinero en efectivo',
    buttonProcessOrder: 'Procesa tu pedido',
    titleEmpty: 'Tu carrito esta vacío',
    subtitleEmpty: 'Parece que aún no has añadido nada a tu carrito',
    bthShopNow: 'Compra ahora',
    successOrder: '¡Su pedido fue enviado con éxito!',
    errorOrder: 'Su pedido no fue enviado',
    bthHome: 'Ir a casa',
    quantity: 'ctd',
  },
  contacts: {
    ask: 'Pregunta en',
    orderWhatsApp: 'Orden en WhatsApp',
  },
  donation: {
    textBuy: 'Comprar',
    fieldComment: 'Di algo agradable... (opcional)',
    buttonSupport: 'Apoyo',
  },
  category: {
    all: 'Toda',
    noItems: 'No hay artículos',
  },
  link: {
    visitLink: 'Visitar enlace',
  },
  error: {
    correctEmail: 'Ingrese el correo electrónico correcto',
    emptyField: 'El campo no puede estar vacío',
  },
  sort: {
    title: 'Clasificación',
    search: 'Búsqueda',
    default: 'Orden predeterminado',
    dateNew: 'Fecha: del más nuevo al más antiguo',
    dateOld: 'Fecha: del más antiguo al más reciente',
    priceLow: 'Precios de barato a caro',
    priceHigh: 'Precio: de mayor a menor',
    nameA: 'Nombre: de la A a la Z',
    nameZ: 'Nombre: de la Z a la A',
  },
  shop: {
    notify: 'Notificarme',
    itemsLeft: 'quedan  artículos',
    notAvailable: 'No disponible',
    available: 'Disponible',
    similar: 'También recomendamos',
    similarEmpty: 'No se encontraron productos similares',
  },
};

export const ptLang = {
  common: {
    lauching: 'Lançamento',
    showMore: 'Mostre mais',
    share: 'Compartilhar',
  },
  bio: {
    expand: 'Ver mais',
  },
  timer: {
    days: 'Dias',
    hours: 'Horas',
    min: 'Minutos',
    sec: 'Segundos',
  },
  form: {
    email: 'O email',
    name: 'Nome',
    phone: 'Telefone',
    comment: 'Comente (opcional)',
    address: 'Endereço',
    insta: 'Conta do Instagram',
    submitEmail: 'Enviamos informações para o seu e-mail',
    total: 'Total',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    enterName: 'Insira o nome e o sobrenome',
    enterEmail: 'Digite o e-mail',
    enterAddress: 'Insira o endereço',
    enterComment: 'СComente (opcional)',
    thankYou: 'Obrigado!',
    error: 'Algo deu errado',
    successEmail: 'Seu e-mail foi enviado com sucesso',
    successPhone: 'Seu telefone foi enviado com sucesso',
  },
  basket: {
    addItem: 'Adicionar ao carrinho',
    itemAdded: 'Item adicionado ao seu carrinho',
    orderNow: 'Peça agora',
    goToCart: 'Vá para o carrinho',
    continue: 'Continue comprando',
    shoppingCart: 'Carrinho de compras',
    submitOrder: 'Enviar pedido',
    cancel: 'Cancelar',
    items: 'Produtos',
    total: 'Total',
    shipping: 'Entrega',
    shippingName: 'Digite o nome e sobrenome',
    shippingEmail: 'Digite o e-mail',
    shippingAddress: 'Insira o endereço',
    shippingComment: 'Escreva um comentário (opcional)',
    paymentMethod: 'Forma de pagamento',
    stripe: 'Pagamento com Stripe',
    wayforpay: 'Cartão de débito ou crédito',
    cash: 'Dinheiro',
    buttonProcessOrder: 'Processe seu pedido',
    titleEmpty: 'Sua cesta está vazia',
    subtitleEmpty: 'Parece que você ainda não adicionou nada ao seu carrinho',
    bthShopNow: 'Compre agora',
    successOrder: 'Seu pedido foi enviado com sucesso!',
    errorOrder: 'Seu pedido não foi enviado',
    bthHome: 'Para a página inicial',
    quantity: 'quant',
  },
  contacts: {
    ask: 'Pergunte no',
    orderWhatsApp: 'Pedido no WhatsApp',
  },
  donation: {
    textBuy: 'Comprar',
    fieldComment: 'Diga algo legal... (opcional)',
    buttonSupport: 'Apoio, suporte',
  },
  category: {
    all: 'Tudo',
    noItems: 'Nenhum item',
  },
  link: {
    visitLink: 'Acesse o link',
  },
  error: {
    correctEmail: 'Digite o e-mail correto',
    emptyField: 'O campo não pode ficar vazio',
  },
  sort: {
    title: 'Ordenação',
    search: 'Procurar',
    default: 'Classificação padrão',
    dateNew: 'Data: do mais recente ao mais antigo',
    dateOld: 'Data: Do mais antigo para o mais recente',
    priceLow: 'Preço: Baixo a Alto',
    priceHigh: 'Preço: Alto a Baixo',
    nameA: 'Nome: A a Z',
    nameZ: 'Nome: Z a A',
  },
  shop: {
    notify: 'Me avise',
    itemsLeft: 'itens restantes',
    notAvailable: 'Não disponível',
    available: 'Acessível',
    similar: 'Também recomendado',
    similarEmpty: 'Produtos similares não encontrados',
  },
};

export const frLang = {
  common: {
    lauching: 'Lançamento',
    showMore: 'Montre plus',
    share: 'Partager',
  },
  bio: {
    expand: 'Voir plus',
  },
  timer: {
    days: 'Jours',
    hours: 'Les heures',
    min: 'Minutes',
    sec: 'Secondes',
  },
  form: {
    email: 'E-mail',
    name: 'Nom',
    phone: 'Téléphone',
    comment: 'Commenter (facultatif)',
    address: 'Adresse',
    insta: 'Compte Instagram',
    submitEmail: 'Nous avons envoyé des informations à votre e-mail',
    total: 'Total',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    enterName: 'Entrez le prénom et le nom',
    enterEmail: "Entrez l'email",
    enterAddress: "Entrer l'adresse",
    enterComment: 'Entrez un commentaire (facultatif)',
    thankYou: 'Merci!',
    error: 'Un problème est survenu',
    successEmail: 'Votre e-mail a été soumis avec succès',
    successPhone: 'Votre téléphone a été soumis avec succès',
  },
  basket: {
    addItem: 'Ajouter au panier',
    itemAdded: 'Article ajouté à votre panier',
    orderNow: 'Commandez maintenant',
    goToCart: 'Aller au panier',
    continue: 'Continuer vos achats',
    shoppingCart: 'Panier',
    submitOrder: 'Soumettre la commande',
    cancel: 'Annuler',
    items: 'Des produits',
    total: 'Le total',
    shipping: 'Livraison',
    shippingName: 'Entrez le prénom et le nom',
    shippingEmail: "Entrez l'e-mail",
    shippingAddress: "Entrer l'adresse",
    shippingComment: 'Écrivez un commentaire (facultatif)',
    paymentMethod: 'Mode de paiement',
    stripe: 'Paiement avec Stripe',
    wayforpay: 'Сarte de crédit',
    cash: 'En espèces',
    buttonProcessOrder: 'Confirmer la commande',
    titleEmpty: 'Votre panier est vide',
    subtitleEmpty: "Vous n'avez encore rien ajouté à votre panier",
    bthShopNow: 'Aller au magasin',
    successOrder: 'Votre commande a été passée avec succès !',
    errorOrder: "Votre commande n'a pas été passée",
    bthHome: 'Retour',
    quantity: 'quant',
  },
  contacts: {
    ask: 'Demandez sur',
    orderWhatsApp: 'Commandez sur WhatsApp',
  },
  donation: {
    textBuy: 'Acheter',
    fieldComment: 'Écrivez un commentaire.. (facultatif)',
    buttonSupport: 'Soutien',
  },
  category: {
    all: 'Tout',
    noItems: "Pas d'objet",
  },
  link: {
    visitLink: 'Suivez le lien',
  },
  error: {
    correctEmail: "Saisissez l'adresse e-mail correcte",
    emptyField: 'Le champ ne peut pas être vide',
  },
  sort: {
    title: 'Tri',
    search: 'Chercher',
    default: 'Tri par défaut',
    dateNew: 'Date : du plus récent au plus ancien',
    dateOld: 'Date : du plus ancien au plus récent',
    priceLow: 'Prix   croissant',
    priceHigh: 'Prix : du plus élevé au plus bas',
    nameA: 'Nom : A à Z',
    nameZ: 'Nom : Z à A',
  },
  shop: {
    notify: 'Prévenez-moi',
    itemsLeft: 'articles restants',
    notAvailable: 'Indisponible',
    available: 'Disponible',
    similar: 'Également recommandé',
    similarEmpty: 'Produits similaires introuvables',
  },
};

export const deLang = {
  common: {
    lauching: 'Starten',
    showMore: 'Zeig mehr',
    share: 'Teilen',
  },
  bio: {
    expand: 'Mehr sehen',
  },
  timer: {
    days: 'Tage',
    hours: 'Std',
    min: 'Protokoll',
    sec: 'Sekunden',
  },
  form: {
    email: 'Email',
    name: 'Name',
    phone: 'Telefon',
    comment: 'Kommentar (optional)',
    address: 'Adresse',
    insta: 'Instagram-Account',
    submitEmail: 'Wir haben Informationen an Ihre E-Mail gesendet',
    total: 'Gesamt',
    firstName: 'Vorname',
    lastName: 'Nachname',
    enterName: 'Geben Sie den Vor- und Nachnamen ein',
    enterEmail: 'Email eingeben',
    enterAddress: 'Adresse eingeben',
    enterComment: 'Kommentar eingeben (optional)',
    thankYou: 'Danke!',
    error: 'Etwas ist schief gelaufen',
    successEmail: 'Ihre E-Mail wurde erfolgreich übermittelt',
    successPhone: 'Ihr Telefon wurde erfolgreich übermittelt',
  },
  basket: {
    addItem: 'In den Warenkorb legen',
    itemAdded: 'Artikel in den Warenkorb gelegt',
    orderNow: 'Jetzt bestellen',
    goToCart: 'Gehe zum Wagen',
    continue: 'Mit dem Einkaufen fortfahren',
    shoppingCart: 'Einkaufswagen',
    submitOrder: 'Bestellung abschicken',
    cancel: 'Stornieren',
    items: 'Produkte',
    total: 'Gesamt',
    shipping: 'Die Zustellung',
    shippingName: 'Geben Sie den Vor- und Nachnamen ein',
    shippingEmail: 'Email eingeben',
    shippingAddress: 'Adresse eingeben',
    shippingComment: 'Kommentar schreiben (optional)',
    paymentMethod: 'Zahlungsmethode',
    stripe: 'Zahlung mit Stripe',
    wayforpay: 'Kredit- oder Debitkarte',
    cash: 'Kasse',
    buttonProcessOrder: 'Bestätige die Bestellung',
    titleEmpty: 'Dein Korb ist leer',
    subtitleEmpty: 'Sie haben Ihrem Warenkorb noch nichts hinzugefügt',
    bthShopNow: 'Zum Laden gehen',
    successOrder: 'Ihre Bestellung wurde erfolgreich aufgegeben!',
    errorOrder: 'Ihre Bestellung wurde nicht aufgegeben',
    bthHome: 'Zurück',
    quantity: 'Anz',
  },
  contacts: {
    ask: 'Fragen Sie in',
    orderWhatsApp: 'Bestellen Sie auf WhatsApp',
  },
  donation: {
    textBuy: 'Kaufen',
    fieldComment: 'Schreiben Sie einen Kommentar.. (optional)',
    buttonSupport: 'Unterstützung',
  },
  category: {
    all: 'Alles',
    noItems: 'Nichts gefunden',
  },
  link: {
    visitLink: 'Folge dem Link',
  },
  error: {
    correctEmail: 'Geben Sie die richtige E-Mail-Adresse ein',
    emptyField: 'Feld darf nicht leer sein',
  },
  sort: {
    title: 'Sortierung',
    search: 'Suche',
    default: 'Standardsortierung',
    dateNew: 'Datum: Vom Neusten zum Ältesten',
    dateOld: 'Datum: Vom Ältesten zum Neuesten',
    priceLow: 'Preis niedrig bis hoch',
    priceHigh: 'Preis: Hoch bis Niedrig',
    nameA: 'Name: A bis Z',
    nameZ: 'Name: Z bis A',
  },
  shop: {
    notify: 'Benachrichtige mich',
    itemsLeft: 'artikel übrig',
    notAvailable: 'Nicht verfügbar',
    available: 'Verfügbar',
    similar: 'Auch empfehlenswert',
    similarEmpty: 'Ähnliche Produkte wurden nicht gefunden',
  },
};

export const itLang = {
  common: {
    lauching: 'In arrivo',
    showMore: 'Mostra di più',
    share: 'Condividi',
  },
  bio: {
    expand: 'Vedi di più',
  },
  timer: {
    days: 'Giorni',
    hours: 'Ore',
    min: 'Minuti',
    sec: 'Secondi',
  },
  form: {
    email: 'Email',
    name: 'Nome',
    phone: 'Telefono',
    comment: 'Commento (facoltativo)',
    address: 'Indirizzo',
    insta: 'Account Instagram',
    submitEmail: 'Abbiamo inviato le informazioni alla tua email',
    total: 'Totale',
    firstName: 'Nome',
    lastName: 'Cognome',
    enterName: 'Nome e cognome',
    enterEmail: 'Email',
    enterAddress: 'Indirizzo',
    enterComment: 'Commento Wripe (facoltativo)',
    thankYou: 'Grazie!',
    error: 'Qualcosa è andato storto',
    successEmail: 'La tua email è stata inviata con successo',
    successPhone: 'Il tuo numero di telefono è stato inviato con successo',
  },
  basket: {
    addItem: 'Aggiungi al carrello',
    itemAdded: 'Aggiunto al carrello',
    orderNow: 'Ordina ora',
    goToCart: 'Vai al carrello',
    continue: 'Continua lo shopping',
    shoppingCart: 'Carrello',
    submitOrder: 'Invia ordine',
    cancel: 'Annulla',
    items: 'Articoli',
    total: 'Totale',
    shipping: 'Spedizione',
    shippingName: 'Inserisci nome e cognome',
    shippingEmail: 'Inserisci email',
    shippingAddress: 'Inserisci indirizzo',
    shippingComment: 'Inserisci commento (facoltativo)',
    paymentMethod: 'Metodo di pagamento',
    stripe: 'Paga con Stripe',
    wayforpay: 'Carta di debito o credito',
    cash: 'Contanti',
    buttonProcessOrder: 'Elabora il tuo ordine',
    titleEmpty: 'Il tuo carrello è vuoto',
    subtitleEmpty: 'Sembra che tu non abbia ancora aggiunto nulla al carrello',
    bthShopNow: 'Acquista ora',
    successOrder: 'Il tuo ordine è stato inviato con successo!',
    errorOrder: 'Il tuo ordine non è stato inviato',
    bthHome: 'Vai alla home',
    quantity: 'Qtà',
  },
  contacts: {
    ask: 'Chiedi su',
    orderWhatsApp: 'Ordina su WhatsApp',
  },
  donation: {
    textBuy: 'Acquista',
    fieldComment: 'Scrivi qualcosa di carino...(facoltativo)',
    buttonSupport: 'Supporto',
  },
  category: {
    all: 'Tutti',
    noItems: 'Nessun articolo',
  },
  link: {
    visitLink: 'Visita link',
  },
  error: {
    correctEmail: "Inserisci un'email valida",
    emptyField: 'il campo non può essere vuoto',
  },
  sort: {
    title: 'Ordina',
    search: 'Cerca',
    default: 'Ordinamento predefinito',
    dateNew: 'Data: dal più recente al meno recente',
    dateOld: 'Data: dal meno recente al più recente',
    priceLow: 'Prezzo: dal più basso al più alto',
    priceHigh: 'Prezzo: dal più alto al più basso',
    nameA: 'Nome: dalla A alla Z',
    nameZ: 'Nome: dalla Z alla A',
  },
  shop: {
    notify: 'Avvisami',
    itemsLeft: 'articoli rimasti',
    notAvailable: 'Non disponibile',
    available: 'Disponibile',
    similar: 'Potrebbe interessarti anche',
    similarEmpty: 'Nessun prodotto simile trovato',
  },
};

export const trLang = {
  common: {
    lauching: 'Başlatılıyor',
    showMore: 'Daha fazla göster',
    share: 'Paylaş',
  },
  bio: {
    expand: 'Daha fazlasını gör',
  },
  timer: {
    days: 'Gün',
    hours: 'Saat',
    min: 'Dakika',
    sec: 'Saniye',
  },
  form: {
    email: 'Email',
    name: 'Ad',
    phone: 'Telefon',
    comment: 'Yorum (isteğe bağlı)',
    address: 'Adres',
    insta: 'Instagram hesabı',
    submitEmail: 'Bilgileri email adresinize gönderdik',
    total: 'Toplam',
    firstName: 'Ad',
    lastName: 'Soyad',
    enterName: 'Ad ve Soyad',
    enterEmail: 'Email',
    enterAddress: 'Adres',
    enterComment: 'Wripe Yorumu (isteğe bağlı)',
    thankYou: 'Teşekkürler!',
    error: 'Bir şeyler ters gitti',
    successEmail: 'Email adresiniz başarıyla gönderildi',
    successPhone: 'Telefon numaranız başarıyla gönderildi',
  },
  basket: {
    addItem: 'Sepete ekle',
    itemAdded: 'Sepete eklendi',
    orderNow: 'Hemen sipariş ver',
    goToCart: 'Sepete git',
    continue: 'Alışverişe devam et',
    shoppingCart: 'Alışveriş sepeti',
    submitOrder: 'Siparişi gönder',
    cancel: 'İptal',
    items: 'Ürünler',
    total: 'Toplam',
    shipping: 'Kargo',
    shippingName: 'Ad ve Soyad girin',
    shippingEmail: 'Email girin',
    shippingAddress: 'Adres girin',
    shippingComment: 'Yorum girin (isteğe bağlı)',
    paymentMethod: 'Ödeme Yöntemi',
    stripe: 'Stripe ile öde',
    wayforpay: 'Banka veya Kredi Kartı',
    cash: 'Nakit',
    buttonProcessOrder: 'Siparişinizi tamamlayın',
    titleEmpty: 'Sepetiniz boş',
    subtitleEmpty: 'Görünüşe göre sepetinize henüz bir şey eklemediniz',
    bthShopNow: 'Alışverişe başla',
    successOrder: 'Siparişiniz başarıyla gönderildi!',
    errorOrder: 'Siparişiniz gönderilmedi',
    bthHome: 'Ana sayfaya git',
    quantity: 'Adet',
  },
  contacts: {
    ask: 'Sor',
    orderWhatsApp: "WhatsApp'tan sipariş ver",
  },
  donation: {
    textBuy: 'Satın al',
    fieldComment: 'Güzel bir şey söyleyin...(isteğe bağlı)',
    buttonSupport: 'Destek',
  },
  category: {
    all: 'Tümü',
    noItems: 'Ürün yok',
  },
  link: {
    visitLink: 'Bağlantıyı ziyaret et',
  },
  error: {
    correctEmail: 'Geçerli bir e-posta girin',
    emptyField: 'alan boş bırakılamaz',
  },
  sort: {
    title: 'Sırala',
    search: 'Ara',
    default: 'Varsayılan sıralama',
    dateNew: 'Tarih: Yeniden eskiye',
    dateOld: 'Tarih: Eskiden yeniye',
    priceLow: 'Fiyat: Düşükten yükseğe',
    priceHigh: 'Fiyat: Yüksekten düşüğe',
    nameA: "İsim: A'dan Z'ye",
    nameZ: "İsim: Z'den A'ya",
  },
  shop: {
    notify: 'Bana haber ver',
    itemsLeft: 'ürün kaldı',
    notAvailable: 'Mevcut değil',
    available: 'Mevcut',
    similar: 'Bunları da beğenebilirsin',
    similarEmpty: 'Benzer ürün bulunamadı',
  },
};
